import launchGame from './gameLauncher';


export default launchGame;
